import './DashboardHeader.css';

const formatDate = (date) => {
  const options = {month: 'short', day: 'numeric', year: 'numeric'};
  return date.toLocaleDateString('en-US', options);
};

export const DashboardHeader = ({label}) => {
  const currentDate = new Date();

  return (
    <div className='date-section'>
      <div className='admin-indicator'>
        <span className='admin-badge'>{label || 'Dashboard'}</span>
      </div>
      <div className='date-display'>{formatDate(currentDate)}</div>
    </div>
  );
};
